export default __webpack_public_path__ + "static/bottom-a4d0814b7ad4b500ae124a5aa917a998.png";